export enum LANGUAGE {
  ENGLISH = "EN",
  KOREAN = "KO",
}

export const LANGUAGES = [
  {
    name: "English",
    code: "EN",
  },
  {
    name: "Korean",
    code: "KO",
  },
];

export const enum PAYLOAD_LANGUAGE {
  ENGLISH = "English",
  KOREAN = "Korean",
}
